export default (_ref => {
  var _ref$disableAds = _ref.disableAds,
    disableAds = _ref$disableAds === void 0 ? false : _ref$disableAds;
  return {
    disableAds
  };
});